import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../../../services/base-component.service';
import { LiquidacaoRetorno } from '../../../../models/pagamento/liquidacao-retorno';
import { InfoEnvioEmp } from '../../../../models/pagamento/InfoEnvioEmp';
import { AslibGridComponent } from '@aslib/components';

@Component({
  selector: 'gpa-liq-nao-processado',
  templateUrl: './nao-processado-liq.component.html',
  providers: [BaseComponentService]
})

export class NaoProcessadoLiqComponent extends BaseComponentService implements OnInit {

  listaNaoProcessado: LiquidacaoRetorno[];
  desabilitarReenviar: boolean;
 
  ngOnInit() {

    this.listaNaoProcessado = [];
    this.desabilitarReenviar = true;

    if (sessionStorage.getItem('IdLiq') != null) {
      const liq = Number(sessionStorage.getItem('IdLiq'));
      this.getLiqsNaoProcessadas(liq);
    } 

  }

  getLiqsNaoProcessadas(fileId: number) {
    this.listaNaoProcessado = [];
    const rota = '/api/LiqRetorno/ObterLiqsRetornados'.concat(`/${fileId}/${false}`);

    this._service.routePrefix = rota;
    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {
      this.aslibLoadingService.complete();
   
      if(data){
        this.getListaLiquidacaoRetonada( data )
      } else {
        this.desabilitarReenviar = true;
        this.exibirAviso('Arquivo em processamento.');
      }
    },
      (error) => {
        this.aslibLoadingService.complete();
        this.exibirErro(error);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );

  }

  getListaLiquidacaoRetonada(dados){

    dados.forEach(liq => {
      const LiqRetorno: LiquidacaoRetorno = new LiquidacaoRetorno();

      LiqRetorno.codigoProjeto = liq.codigoProjeto;
      LiqRetorno.anoExercicio = liq.anoExercicio;
      LiqRetorno.codigoCredor = liq.codigoCredor;
      LiqRetorno.cnpjCpfCredor = liq.cnpjCpfCredor;
      LiqRetorno.nomeCredor = liq.nomeCredor;
      LiqRetorno.numeroProcessoSEI = liq.numeroProcessoSEI;
      LiqRetorno.numeroEmpenho = liq.numEmp;
      LiqRetorno.mensagemErro = liq.mensagemErro;
      LiqRetorno.valor = liq.valorLiquidacao;
      LiqRetorno.numeroObservacao = liq.numeroObservacao;
      LiqRetorno.reenviada = false;

      this.listaNaoProcessado.push(LiqRetorno);

      this.desabilitarReenviar = false;
    });
}

  reenviarLIQ(grid: AslibGridComponent) {
    if (this.listaNaoProcessado.length === 0) {
      this.exibirAviso('Não há dados para a geração e envio da LIQ.');
      return;
    }

    this.aslibLoadingService.start();

    this._service.routePrefix = '/api/LiqEnvio/Reenviar';
    this.subSave = this._service.add(this.listaNaoProcessado, 'gpa').subscribe(data => {

      // atualiza a coluna de sinalização de envio.
      for (let index = 0; index < this.listaNaoProcessado.length; index++) {
        this.listaNaoProcessado[index].reenviada = true;
      }

      this.desabilitarReenviar = true;

      this.exibirSucesso('As LIQs foram reenviados com sucesso.');
    },
      erro => {
        this.aslibLoadingService.complete();
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq/nao-processado/nao-processado-liq.component.ts